/**
 * Carrusel galería — página Primaria (.prim-galeria__splide)
 */
export function marianistaInitPrimGaleria() {
  if (typeof Splide === 'undefined') {
    return;
  }

  document.querySelectorAll('.prim-galeria__splide').forEach((el) => {
    if (el.dataset.primGaleriaMounted === '1') {
      return;
    }
    el.dataset.primGaleriaMounted = '1';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '1.6rem',
      pagination: true,
      arrows: false,
      drag: true,
      trimSpace: false,
      flickMaxPages: 1,
      speed: reducedMotion ? 0 : 450,
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      breakpoints: {
        1280: { perPage: 3, gap: '1.4rem' },
        1024: { perPage: 2, gap: '1.2rem' },
        768: { perPage: 1, gap: '1rem' },
      },
    }).mount();
  });
}
